<template>
<div style="width: 100%;">
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">



<filters :msg="msg"></filters>



  <v-layout d-flex>
  <v-card>
    <v-toolbar height="42" flat>
      <v-toolbar-title>
  <v-icon color="#4A76A8" left>mdi-message</v-icon>
   <span v-if="$store.state.msg.displayDataMsg.dataCount >= 0"> Сообщения ({{$store.state.msg.displayDataMsg.msgCount}}) </span>
   <span v-else style="color:gray"> Загрузка сообщений... </span>
      </v-toolbar-title>
   <v-spacer></v-spacer>
<v-icon @click="msg.modals.filter = true" color="#273C51">mdi-filter</v-icon>
<v-icon color="#273C51">mdi-settings</v-icon>
<v-icon color="red">mdi-delete</v-icon>
    </v-toolbar>
  <v-card-text>


<!--{{this.$store.state.msg.text}}-->


<table class="table" >
  <thead>
    <tr>
      <th scope="col" style="padding-left:0px">Отправитель</th>
      <th scope="col" style="padding-left:0px">Получатель</th>
      <th scope="col" style="padding-left:0px">Сообщения</th>

    </tr>
  </thead>
  <tbody>


    <tr v-if="item.lastMsg.text" @click="selecetReceptor(item)" v-for="item in display.items"  style="cursor: pointer;">

      <td style="padding:0px">
         <v-list  dense two-line  >
              <v-list-tile >
                <v-list-tile-avatar style="margin-left:-15px">
                  <img :src="display.users[item.senderId].photo_50" alt="ошибка">
                </v-list-tile-avatar>

                <v-list-tile-content  >
                  <v-list-tile-title  >
   <a style="text-decoration:none" target="_blank" :href="'https://vk.com/id'+item.senderId"> {{display.users[item.senderId].first_name }} {{display.users[item.senderId].last_name}}</a>
                  </v-list-tile-title>

                  <v-list-tile-sub-title  >
              {{$store.state.ui.profilesGroups[display.users[item.senderId].gr_id].title_ru}}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
          </v-list>
      </td>




      <td style="padding:0px">
        <v-list dense two-line  >
             <v-list-tile>
               <v-list-tile-avatar style="margin-left:-15px">
                 <img :src="display.users[item.receptorId].photo_50" alt="ошибка">
               </v-list-tile-avatar>

               <v-list-tile-content>
                 <v-list-tile-title  >
  <a style="text-decoration:none" target="_blank" :href="'https://vk.com/id'+item.receptorId"> {{display.users[item.receptorId].first_name }} {{display.users[item.receptorId].last_name}}</a>
                 </v-list-tile-title>

                 <v-list-tile-sub-title  >
                   <div style="max-width:100px;overflow:hidden" v-if="display.users[item.receptorId].source_info">
                   <v-avatar size="20" style="margin-right:5px">
                   <img :src="display.users[item.receptorId].source_info.source_img" alt="ошибка">
                   </v-avatar>
                   <a style="text-decoration:none" target="_blank" :href="'https://vk.com/club'+display.users[item.receptorId].source_info.source_id">{{display.users[item.receptorId].source_info.source_title}}</a>
                   </div>
                   <div v-else>
                   <span>Неизвестный источник</span>
                   </div>
                 </v-list-tile-sub-title>
               </v-list-tile-content>
             </v-list-tile>
         </v-list>


      </td>





      <td   style="padding:0px"   >
        <v-list  dense two-line  >
             <v-list-tile>
               <v-list-tile-avatar style="margin-left:-15px">
                <img :src="display.users[item.lastMsg.from_id].photo_50" alt="ошибка">

               </v-list-tile-avatar>

               <v-list-tile-content>


                   <v-list-tile-title  >
                  <v-layout>
                  <v-flex>
                   <a style="text-decoration:none" target="_blank" :href="'https://vk.com/id'+item.lastMsg.from_id"> {{display.users[item.lastMsg.from_id].first_name }} {{display.users[item.lastMsg.from_id].last_name}}</a>
                  </v-flex>
                  <span style="color:gray;font-size:.8em">{{item.lastMsg.date|dateFormatFull}}</span>
                  </v-layout>
                   </v-list-tile-title  >


                 <v-list-tile-sub-title>
                   <v-avatar v-if="item.senderId == item.lastMsg.from_id" size="20" style="margin-right:5px">
                   <img :src="display.users[item.senderId].photo_50" alt="ошибка">
                   </v-avatar>
                   <span v-if="item.senderId == item.lastMsg.from_id">

                   <span v-if="item.lastMsg.read_state>0" style="background-color:gray;color:white;padding:1px">
                      {{item.lastMsg.text.substr(0,40)}}
                   </span>
                   <span v-if="item.lastMsg.read_state<=0" style="color:gray;padding:1px">{{item.lastMsg.text.substr(0,40)}} </span>
                   </span>

                   <span v-else>
                   <span v-if="item.lastMsg.read_state < 0" style="background-color:green;color:white;padding:1px">   {{item.lastMsg.text.substr(0,40)}} </span>
                   <span v-if="item.lastMsg.read_state >= 0" style="color:gray;padding:1px">{{item.lastMsg.text.substr(0,40)}} </span>
                   </span>

                 </v-list-tile-sub-title>


               </v-list-tile-content>
             </v-list-tile>
         </v-list>
      </td>

    </tr>



<!-- Если нет такого сообещения уже  -->
<tr v-if="!item.lastMsg.text"  v-for="item in display.items"  style="cursor: pointer;">

  <td style="padding:0px">
     <v-list  dense two-line  >
          <v-list-tile >
            <v-list-tile-avatar style="margin-left:-15px">
              <img :src="display.users[item.senderId].photo_50" alt="ошибка">
            </v-list-tile-avatar>

            <v-list-tile-content  >
              <v-list-tile-title  >
<a style="text-decoration:none" target="_blank" :href="'https://vk.com/id'+item.senderId"> {{display.users[item.senderId].first_name }} {{display.users[item.senderId].last_name}}</a>
              </v-list-tile-title>

              <v-list-tile-sub-title  >
       <span v-if="display.users[item.senderId].gr_id >= 0">
          {{$store.state.ui.profilesGroups[display.users[item.senderId].gr_id].title_ru}}
       </span>
       <span v-else style="color:red">
          Удаленный аккаунт
       </span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
      </v-list>
  </td>




  <td style="padding:0px">
    <v-list dense two-line  >
         <v-list-tile>
           <v-list-tile-avatar style="margin-left:-15px">
             <img :src="display.users[item.receptorId].photo_50" alt="ошибка">
           </v-list-tile-avatar>

           <v-list-tile-content>
             <v-list-tile-title  >
<a style="text-decoration:none" target="_blank" :href="'https://vk.com/id'+item.receptorId"> {{display.users[item.receptorId].first_name }} {{display.users[item.receptorId].last_name}}</a>
             </v-list-tile-title>

             <v-list-tile-sub-title  >
<div style="max-width:100px;overflow:hidden" v-if="display.users[item.receptorId].source_info">
<v-avatar size="20" style="margin-right:5px">
<img :src="display.users[item.receptorId].source_info.source_img" alt="ошибка">
</v-avatar>
<a style="text-decoration:none" target="_blank" :href="'https://vk.com/club'+display.users[item.receptorId].source_info.source_id">{{display.users[item.receptorId].source_info.source_title}}</a>
</div>
<div v-else>
<span>Неизвестный источник</span>
</div>
             </v-list-tile-sub-title>
           </v-list-tile-content>
         </v-list-tile>
     </v-list>


  </td>





  <td  style="padding:20px" >

  <span v-if="display.users[item.senderId].gr_id >= 0" style="color:red">Сообщение удалено.</span>
  <span v-else style="color:red">Нет доступа.</span>
  </td>

</tr>

  </tbody>
</table>

<v-layout justify-center>
<span v-if="$store.state.msg.isLoadingMsg" style="color:green">Выполняется загрузка...</span>
</v-layout>

<v-layout  @click="changeList()"   justify-center>

<v-pagination
  :disabled="$store.state.msg.isLoadingMsg"
  v-model="$store.state.msg.page"
  :length="display.dataCount"
  total-visible="10"

></v-pagination>
</v-layout>



<chat v-if="$store.state.msg.dialogModal" :msg="msg" :inits="inits"></chat>



  </v-card-text>


  </v-card>

  </v-layout>






</div>
</template>




<script>
import axios from 'axios'
import chat from './chat.vue'
import filters from './filter.vue'
export default {
props:['init' ],
components:{chat,filters},
 data: function(){
  return {
inits: {
type: 'getAllwithOffset',
limit: 5,
offset:0,
},

msg:{
  selectedReceptor: {},
  modals: {
    chat: false,
    filter: false,
  },
},



}
},

methods:{
// getAllwithOffset getBySenderWithOffset
changeList(){

if(this.$store.state.msg.page == 1){
  this.inits.offset = 0
} else {
  this.inits.offset = this.$store.state.msg.page * this.inits.limit - this.inits.limit
}
this.$store.dispatch('getMsgWithParams',{init:this.inits})
},


selecetReceptor(item){
  this.msg.selectedReceptor = item
  this.$store.state.msg.dialogModal =  true
},



},

computed:{
display(){
	return  this.$store.state.msg.displayDataMsg
},

},

created (){
this.$store.state.msg.page = 1
this.$store.state.msg.displayDataMsg = []
if(this.init){
  this.inits = {}
  this.inits = this.init
}

  this.changeList()

},


filters:{

  dateFormat(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    // return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":"+ d.getMinutes()
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }
    return  d.getHours() +":"+ mins
  },
  dateFormatFull(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }
    return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":" + mins

  }
},
}
</script>

<style>

 .row-selected {
   background-color: red
 }
</style>
